import type MenuItem from 'types/MenuItem'
import type { Item } from '@tictuk/item-availability'
import { isItemAvailable } from '@tictuk/item-availability'

export default function filterItemsAvailability(items: MenuItem[]) {
	return items.filter((item) => isItemAvailable(item as Item, new Date()))
}
